module.exports = __webpack_public_path__ + "static/img/PromptPay2.2cb0cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shipping/PromptPay2.png
// module id = iyPs
// module chunks = 31